var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReaction = function SvgReaction(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M6.25 7.024 4.774 2.97a1.042 1.042 0 0 1 1.959-.713l1.466 4.028"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M8.198 6.285 6.875 2.648a1.042 1.042 0 0 1 1.958-.712l1.859 5.109M6.25 7.024 5.365 4.59a1.083 1.083 0 0 0-1.253-.708 1.042 1.042 0 0 0-.725 1.367l2.162 5.94a.104.104 0 0 1-.156.123L3.05 9.765l-.648-.428a1.04 1.04 0 0 0-1.186 1.7l5.414 4.89c.02.016.042.03.063.045"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "m12 4.567-.477-1.33a1.083 1.083 0 0 0-1.253-.709 1.042 1.042 0 0 0-.725 1.367l1.147 3.151M11.799 9.408l2.824-5.34a1.041 1.041 0 0 1 1.841.973l-2.823 5.341"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "m13.64 10.382 2.63-4.973a1.042 1.042 0 0 1 1.841.973l-2.629 4.973"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "m15.482 11.355 1.655-3.13a1.04 1.04 0 0 1 1.5-.38 1.084 1.084 0 0 1 .314 1.405l-3.672 6.947a4.795 4.795 0 0 1-9.029-2.06V6.842a1.042 1.042 0 0 1 2.058-.259l.118.767.426 2.774a.104.104 0 0 0 .195.033L12 4.567a1.04 1.04 0 0 1 1.5-.38 1.084 1.084 0 0 1 .314 1.406l-2.017 3.815"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReaction);
export default ForwardRef;